import React, { FC } from 'react'

import { Tracking } from '@Components/CMS/Tracking'

interface TrackingDisplayBlockProps {
  id?: string
}

const TrackingDisplayBlock: FC<TrackingDisplayBlockProps> = ({ id }) => (<Tracking id={id} />)

export default TrackingDisplayBlock
